"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundingRequestComponentTypeSchema = exports.FundingRequestComponentType = void 0;
const zod_1 = require("zod");
// @deprecated: use FundingRequestComponentTypeNew instead
var FundingRequestComponentType;
(function (FundingRequestComponentType) {
    FundingRequestComponentType["CollectionsPaydown"] = "collectionsPaydown";
    FundingRequestComponentType["CollectionsRecycle"] = "collectionsRecycle";
    FundingRequestComponentType["CurePaydown"] = "curePaydown";
    FundingRequestComponentType["DrawRequest"] = "drawRequest";
})(FundingRequestComponentType || (exports.FundingRequestComponentType = FundingRequestComponentType = {}));
exports.FundingRequestComponentTypeSchema = zod_1.z.enum([
    'collectionsPaydown',
    'collectionsRecycle',
    'curePaydown',
    'drawRequest',
]);
//# sourceMappingURL=SharedFundingRequest.js.map